module.exports = __webpack_public_path__ + "static/media/snake.2524c0d9.jpg";